import React from 'react';

import { useSelector } from 'react-redux';
import { Role, AppStore } from 'domain/models';

/**
 * Each ROLE_TIERS index represents the weight.
 */
const ROLE_TIERS: Role[] = [ 'ROLE_USER', 'ROLE_EXPLORER', 'ROLE_ADMIN'];

export interface WithRoleProps {
  role?: Role;
  exact?: boolean;
  action?: 'hide' | 'disable' | 'destroy';
  showOverlay?: boolean;
}

export const isEqualOrHigherTierByKey = (roles: Role[], expectedRole?: Role, exact?: boolean): boolean => {
  if (!expectedRole) {
    /* If we do not expect any role, show */
    return true;
  }
  if (exact) {
    return roles.includes(expectedRole);
  }
  const maxWeight = Math.max(-1, ...roles.map(r => ROLE_TIERS.indexOf(r)));
  const expectedWeight  = ROLE_TIERS.indexOf(expectedRole);
  return maxWeight >= expectedWeight;
};

export const WithRole = React.forwardRef<
  any,
  React.PropsWithChildren<WithRoleProps>
>(
  (
    {
      action = 'hide',
      exact = false,
      role,
      children
    }: React.PropsWithChildren<WithRoleProps>,
    ref: any
  ) => {
    const userRoles = useSelector((store: AppStore) => store.auth.user?.roles);

    if (isEqualOrHigherTierByKey(userRoles || [], role, exact)) {
      return children;
    } else {
      switch (action) {
        case 'destroy':
          return null;
        case 'disable':
          return React.Children.map(children, (child: any) =>
            React.cloneElement(child, {
              className: `${child.className || ''} disabled-by-tier`
            })
          ) as any;
        case 'hide':
        default:
          return React.Children.map(children, (child: any) =>
            React.cloneElement(child, {
              style: { visibility: 'hidden' }
            })
          ) as any;
      }
    }
  }
);
